import { Routes } from '@angular/router';
import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component';
import { PagesLayoutComponent } from './Layout/pages-layout/pages-layout.component';
import { AcompanharPtComponent } from './pages/pt/acompanhar-pt/acompanhar-pt.component';
import { AcompanharSSComponent } from './pages/ss/acompanhar-ss/acompanhar-ss.component';
import { AvaliarSSComponent } from './pages/ss/avaliar-ss/avaliar-ss.component';
import { EmitirOSComponent } from './pages/os/emitir-os/emitir-os.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginPageComponent } from './pages/acesso/login-page/login-page.component';
import { ProgramarServicoComponent } from './pages/programarServico/programar-servico.component';
import { CadastrarPTComponent } from './pages/pt/cadastro-pt/cadastrar-pt.component';
import { ListaPTComponent } from './pages/pt/lista-pt/lista-pt.component';
import { SolicitarPtComponent } from './pages/pt/solicitar-pt/solicitar-pt.component';
import { SolicitarSSCadastrarComponent } from './pages/ss/solicitar-ss/solicitar-ss-cadastrar.component';
import { SolicitarSSListaComponent } from './pages/ss/solicitar-ss/solicitar-ss-lista.component';
import { SolicitarSSComponent } from './pages/ss/solicitar-ss/solicitar-ss.component';
import { UsuarioPageComponent } from './pages/acesso/usuario-page/usuario-page.component';
import { AuthService } from './services/auth.service';
import { ConsultarOsComponent } from './pages/os/consultar-os/consultar-os.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { IrregularidadeComponent } from './pages/cadastros/irregularidade/irregularidade.component';
import { EmpreiteiraComponent } from './pages/cadastros/empreiteira/empreiteira.component';
import { FecharOsComponent } from './pages/os/fechar-os/fechar-os.component';
import { FabricanteComponent } from './pages/cadastros/fabricante/fabricante.component';
import { MaterialComponent } from './pages/cadastros/material/material.component';
import { CategoriaComponent } from './pages/cadastros/categoria/categoria.component';
import { FuncionarioComponent } from './pages/cadastros/funcionario/funcionario.component';
import { EquipamentoComponent } from './pages/equipamento/equipamento.component';
import { LocalComponent } from './pages/cadastros/local/local.component';
import { AreaTecnicaComponent } from './pages/cadastros/areatecnica/areatecnica.component';
import { RotinaComponent } from './pages/cadastros/rotina/rotina.component';
import { AtividadeComponent } from './pages/cadastros/atividade/atividade.component';
import { EmitirOsAutomaticaComponent } from './pages/os/emitir-os-automatica/emitir-os-automatica.component';
import { NotAuthorizedComponent } from './errors/not-authorized/not-authorized.component';
import { UnderConstructionComponent } from './errors/under-construction/under-construction.component';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { FuncionalidadesComponent } from './pages/acesso/funcionalidades/funcionalidades.component';
import { UsuarioAlterarSenhaPageComponent } from './pages/acesso/usuario-page/usuario-alterar-senha-page.component';
import { EstoqueComponent } from './pages/cadastros/estoque/estoque.component';
import { ClasseEquipamentoComponent } from './pages/cadastros/classe-equipamento/classe-equipamento.component';
import { GrupoLocalNivelComponent } from './pages/cadastros/grupo-local-nivel/grupo-local-nivel.component';
import { CentroCustoComponent } from './pages/cadastros/centro-custo/centro-custo.component';
import { PrioridadeComponent } from './pages/cadastros/prioridade/prioridade.component';
import { TipoequipamentoComponent } from './pages/cadastros/tipoequipamento/tipoequipamento.component';
import { HistoricoEquipamentoComponent } from './pages/historico-equipamento/historico-equipamento.component';
import { SatisfacaoServicoComponent } from './pages/satisfacao-servico/satisfacao-servico.component';
import { TipoMaterialComponent } from './pages/cadastros/tipo-material/tipo-material.component';
import { QuantitativoServicosComponent } from './pages/quantitativo-servicos/quantitativo-servicos.component';
import { EquipamentoRdComponent } from './pages/relatorios-diarios-rd/equipamento-rd/equipamento-rd.component';
import { ModelosRdComponent } from './pages/relatorios-diarios-rd/modelos-rd/modelos-rd.component';
import { EmissaoRdComponent } from './pages/relatorios-diarios-rd/emissao-rd/emissao-rd.component';
import { CalendarioMensalComponent } from './pages/os/calendario-mensal/calendario-mensal.component';
import { EntradaMaterialComponent } from './pages/entrada-material/entrada-material.component';
import { EntradasPeriodoComponent } from './pages/entradas-periodo/entradas-periodo.component';
import { TratarOSAvaliadaComponent } from './pages/tratar-osavaliada/tratar-osavaliada.component';
import { VistoDeExecucaoComponent } from './pages/os/visto-de-execucao/visto-de-execucao.component';
import { ValidarOsComponent } from './pages/os/validar-os/validar-os.component';
const ɵ0 = { extraParameter: '' }, ɵ1 = { extraParameter: 'homeMenu' }, ɵ2 = { extraParameter: 'acessoAoSistema' }, ɵ3 = { extraParameter: 'ordemservico' }, ɵ4 = { extraParameter: 'ordemservico' }, ɵ5 = { extraParameter: 'ordemservico' }, ɵ6 = { extraParameter: 'ordemservico' }, ɵ7 = { extraParameter: 'ordemservico' }, ɵ8 = { extraParameter: 'consultasgerenciais' }, ɵ9 = { extraParameter: 'consultasgerenciais' }, ɵ10 = { extraParameter: 'consultasgerenciais' }, ɵ11 = { extraParameter: 'dashboard' }, ɵ12 = { extraParameter: 'dashboard' }, ɵ13 = { extraParameter: 'cadastrosEstruturais' }, ɵ14 = { extraParameter: 'cadastrosEstruturais' }, ɵ15 = { extraParameter: 'ordemservico' }, ɵ16 = { extraParameter: 'cadastrosBasicos' }, ɵ17 = { extraParameter: 'cadastrosBasicos' }, ɵ18 = { extraParameter: 'estoque-materiais' }, ɵ19 = { extraParameter: 'estoque-materiais' }, ɵ20 = { extraParameter: 'estoque-materiais' }, ɵ21 = { extraParameter: 'estoque-materiais' }, ɵ22 = { extraParameter: 'cadastrosBasicos' }, ɵ23 = { extraParameter: 'cadastrosBasicos' }, ɵ24 = { extraParameter: 'cadastrosEstruturais' }, ɵ25 = { extraParameter: 'cadastrosEstruturais' }, ɵ26 = { extraParameter: 'cadastrosEstruturais' }, ɵ27 = { extraParameter: 'planoBasicoManutencao' }, ɵ28 = { extraParameter: 'planoBasicoManutencao' }, ɵ29 = { extraParameter: 'planoBasicoManutencao' }, ɵ30 = { extraParameter: '' }, ɵ31 = { extraParameter: 'relatorios-rd' }, ɵ32 = { extraParameter: 'relatorios-rd' }, ɵ33 = { extraParameter: 'relatorios-rd' }, ɵ34 = { extraParameter: 'solicitante' }, ɵ35 = { extraParameter: 'solicitante' }, ɵ36 = { extraParameter: 'gestorSpv' }, ɵ37 = { extraParameter: 'ordemservico' }, ɵ38 = { extraParameter: 'solicitantept' }, ɵ39 = { extraParameter: 'solicitantept' }, ɵ40 = { extraParameter: 'acessoAoSistema' }, ɵ41 = { extraParameter: 'acessoAoSistema' }, ɵ42 = { extraParameter: 'cadastrosEstruturais' }, ɵ43 = { extraParameter: 'consultasgerenciais' }, ɵ44 = { extraParameter: 'consultasgerenciais' }, ɵ45 = { extraParameter: 'cadastrosEstruturais' }, ɵ46 = { extraParameter: 'cadastrosEstruturais' }, ɵ47 = { extraParameter: 'cadastrosEstruturais' }, ɵ48 = { extraParameter: 'cadastrosEstruturais' }, ɵ49 = { extraParameter: 'homeMenu' };
const routes = [
    {
        path: '',
        component: PagesLayoutComponent,
        children: [
            { path: '', component: LoginPageComponent, data: ɵ0 },
        ],
    },
    {
        path: '',
        canActivate: [AuthService],
        component: BaseLayoutComponent,
        children: [
            {
                path: 'home',
                component: HomeComponent,
                data: ɵ1,
            },
            {
                path: 'usuario',
                component: UsuarioPageComponent,
                data: ɵ2,
            },
            {
                path: 'emitir-os',
                component: EmitirOSComponent,
                data: ɵ3,
            },
            {
                path: 'emitir-os-automatica',
                component: EmitirOsAutomaticaComponent,
                data: ɵ4,
            },
            {
                path: 'tratar-os-avaliada',
                component: TratarOSAvaliadaComponent,
                data: ɵ5,
            },
            {
                path: 'visto-de-execucao',
                component: VistoDeExecucaoComponent,
                data: ɵ6,
            },
            {
                path: 'validar-os',
                component: ValidarOsComponent,
                data: ɵ7,
            },
            {
                path: 'consultar-os',
                component: ConsultarOsComponent,
                data: ɵ8,
            },
            {
                path: 'historico-equipamento',
                component: HistoricoEquipamentoComponent,
                data: ɵ9,
            },
            {
                path: 'satisfacao-servico',
                component: SatisfacaoServicoComponent,
                data: ɵ10,
            },
            {
                path: 'dashboard',
                component: DashboardComponent,
                data: ɵ11,
            },
            {
                path: 'quantitativo-servico',
                component: QuantitativoServicosComponent,
                data: ɵ12,
            },
            {
                path: 'irregularidade',
                component: IrregularidadeComponent,
                data: ɵ13,
            },
            {
                path: 'empreiteira',
                component: EmpreiteiraComponent,
                data: ɵ14,
            },
            {
                path: 'fechar-os',
                component: FecharOsComponent,
                data: ɵ15,
            },
            {
                path: 'fabricante',
                component: FabricanteComponent,
                data: ɵ16,
            },
            {
                path: 'estoque',
                component: EstoqueComponent,
                data: ɵ17,
            },
            {
                path: 'material',
                component: MaterialComponent,
                data: ɵ18,
            },
            {
                path: 'tipo-material',
                component: TipoMaterialComponent,
                data: ɵ19,
            },
            {
                path: 'entrada-material',
                component: EntradaMaterialComponent,
                data: ɵ20,
            },
            {
                path: 'entrada-periodo',
                component: EntradasPeriodoComponent,
                data: ɵ21,
            },
            {
                path: 'categoria',
                component: CategoriaComponent,
                data: ɵ22,
            },
            {
                path: 'funcionario',
                component: FuncionarioComponent,
                data: ɵ23,
            },
            {
                path: 'equipamento',
                component: EquipamentoComponent,
                data: ɵ24,
            },
            {
                path: 'local',
                component: LocalComponent,
                data: ɵ25,
            },
            {
                path: 'areatecnica',
                component: AreaTecnicaComponent,
                data: ɵ26,
            },
            {
                path: 'rotina',
                component: RotinaComponent,
                data: ɵ27,
            },
            {
                path: 'atividade',
                component: AtividadeComponent,
                data: ɵ28,
            },
            {
                path: 'calendario-mensal',
                component: CalendarioMensalComponent,
                data: ɵ29,
            },
            {
                path: 'alterar-senha',
                component: UsuarioAlterarSenhaPageComponent,
                data: ɵ30,
            },
            {
                path: 'equipamento-rd',
                component: EquipamentoRdComponent,
                data: ɵ31,
            },
            {
                path: 'modelo-rd',
                component: ModelosRdComponent,
                data: ɵ32,
            },
            {
                path: 'emitir-rd',
                component: EmissaoRdComponent,
                data: ɵ33,
            },
            {
                path: 'solicitar-spv',
                component: SolicitarSSComponent,
                data: ɵ34,
                children: [
                    { path: '', component: SolicitarSSCadastrarComponent },
                    { path: 'cadastrar', component: SolicitarSSCadastrarComponent },
                    { path: 'cadastrar/:id', component: SolicitarSSCadastrarComponent },
                    { path: 'lista', component: SolicitarSSListaComponent },
                ],
            },
            {
                path: 'acompanhar-spv',
                component: AcompanharSSComponent,
                data: ɵ35,
            },
            {
                path: 'avaliar-spv',
                component: AvaliarSSComponent,
                data: ɵ36,
            },
            {
                path: 'programar-servico',
                component: ProgramarServicoComponent,
                data: ɵ37,
            },
            {
                path: 'solicitar-pt',
                component: SolicitarPtComponent,
                data: ɵ38,
                children: [
                    { path: '', component: CadastrarPTComponent },
                    { path: 'cadastrar', component: CadastrarPTComponent },
                    { path: 'cadastrar/:id', component: CadastrarPTComponent },
                    { path: 'lista', component: ListaPTComponent },
                ],
            },
            {
                path: 'acompanhar-pt',
                component: AcompanharPtComponent,
                data: ɵ39,
            },
            {
                path: 'funcionalidades',
                component: FuncionalidadesComponent,
                data: ɵ40,
            },
            {
                path: 'not-authorized',
                component: NotAuthorizedComponent,
                data: ɵ41,
            },
            {
                path: 'centro-custo',
                component: CentroCustoComponent,
                data: ɵ42,
            },
            /*  { path: 'consultar-pbm', component: UnderConstructionComponent, data: { extraParameter: 'consultasgerenciais' } }, */
            {
                path: 'consumo-material',
                component: UnderConstructionComponent,
                data: ɵ43,
            },
            {
                path: 'historico-funcionarios-he',
                component: UnderConstructionComponent,
                data: ɵ44,
            },
            {
                path: 'classe-equipamento',
                component: ClasseEquipamentoComponent,
                data: ɵ45,
            },
            {
                path: 'grupo-local-nivel',
                component: GrupoLocalNivelComponent,
                data: ɵ46,
            },
            {
                path: 'prioridade',
                component: PrioridadeComponent,
                data: ɵ47,
            },
            {
                path: 'tipo-equipamento',
                component: TipoequipamentoComponent,
                data: ɵ48,
            },
            {
                path: 'not-found',
                component: NotFoundComponent,
                data: ɵ49,
            }
        ],
    },
    { path: '**', redirectTo: 'not-found' },
];
/* if (APP_SETTINGS.tipoInstalacao === 'SS' || APP_SETTINGS.tipoInstalacao === 'SSPT')
{ rotasSpv.forEach(r => routes[1].children.push(r)); }
if (APP_SETTINGS.tipoInstalacao === 'PT'  || APP_SETTINGS.tipoInstalacao === 'SSPT') { rotasPT.forEach(r => routes[1].children.push(r)); }

routes.push({ path: '**', redirectTo: 'home' });*/
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ40, ɵ41, ɵ42, ɵ43, ɵ44, ɵ45, ɵ46, ɵ47, ɵ48, ɵ49 };
